export const taskListActions = {
  UPDATE_TASKLIST: 'UPDATE_TASKLIST',
};

export const taskListReducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case taskListActions.UPDATE_TASKLIST: {
      debugger;
      localStorage.setItem('taskList', JSON.stringify({...state, taskList: payload}))
      return {
        ...state,
        taskList: payload,
      };
    }

    default:
      return state;
  }
};